import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export const isBICValid: ValidatorFn = (control: UntypedFormGroup): {[key: string]: any} | null => {
  const bicMinLength = 1;
  const reg = new RegExp('[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?');

  if (control.value !== null && control.value.length >= bicMinLength && !reg.test(control.value)) {
    return { BICNotValid: true };
  }

  return null;
};
